/**
 * Blog Grid Slider Component
 * Mobile slider, desktop grid
 */
if (!customElements.get('blog-slider')) {
  customElements.define(
    'blog-slider',
    class BlogSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          articlesWrap: '.blog-grid__articles',
          grid: '.blog-grid__grid',
        };

        this.classes = {
          slider: 'blog-grid__articles--slider',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
          swiperSlide: 'swiper-slide',
        };

        this.sectionId = this.dataset.sectionId;
        this.enableSliderMobile = this.dataset.enableSliderMobile === 'true';
        this.items = parseInt(this.dataset.items) || 3;

        this.elements = {
          articlesWrap: this.querySelector(this.selectors.articlesWrap),
          grid: this.querySelector(this.selectors.grid),
        };

        this.sliderInstance = false;

        if (!this.enableSliderMobile) return;
        if (!this.elements.articlesWrap || !this.elements.grid) return;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        if (FoxTheme.config.mqlMobile) {
          this.initSlider();
        } else {
          this.destroySlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        // Add classes
        this.elements.articlesWrap.classList.add(this.classes.slider);
        this.elements.articlesWrap.classList.add(this.classes.swiper);
        this.elements.grid.classList.add(this.classes.swiperWrapper);

        // Convert grid items to slides
        const cards = Array.from(this.elements.grid.children);
        cards.forEach((card) => {
          card.classList.add(this.classes.swiperSlide);
        });

        // Find pagination element
        const paginationEl = this.querySelector('.swiper-pagination');

        this.sliderOptions = {
          slidesPerView: 1,
          spaceBetween: 10,
          centeredSlides: true,
          centeredSlidesBounds: true,
          watchOverflow: false,
          watchSlidesProgress: true,
          watchSlidesVisibility: true,
          pagination: paginationEl ? {
            el: paginationEl,
            clickable: true,
            type: 'bullets',
          } : false,
          breakpoints: {
            768: {
              slidesPerView: 3,
              spaceBetween: 0,
              enabled: false
            },
          },
        };

        this.sliderInstance = new window.FoxTheme.Carousel(this.elements.articlesWrap, this.sliderOptions);
        this.sliderInstance.init();
        this.handleAccessibility();
      }

      handleAccessibility() {
        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', (event) => {
            if (event.relatedTarget !== null) {
              if (element.closest('.swiper-slide')) {
                const slide = element.closest('.swiper-slide');
                this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
              }
            } else {
              element.blur();
            }
          });
        });
      }

      destroySlider() {
        // Remove classes
        this.elements.articlesWrap.classList.remove(this.classes.slider);
        this.elements.articlesWrap.classList.remove(this.classes.swiper);
        this.elements.grid.classList.remove(this.classes.swiperWrapper);

        // Remove slide classes
        const cards = Array.from(this.elements.grid.children);
        cards.forEach((card) => {
          card.classList.remove(this.classes.swiperSlide);
        });

        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  );
}
